<template>
  <v-container fluid id="container" class="fill-height">
    <v-row class="text-center">
      <v-col>
        <br><br><br>

        <h2>Welcome</h2>
        <br>
        <h3>Please choose from the menu to get started.</h3>

        <br><br>
        <v-layout column align-center class="py-2 px-7">
          <v-btn color="red" large dark class="mt-4 mb-4\" @click="signOut" >
            <v-icon left>{{mdiLogoutVariant}}</v-icon>
            Sign Out
          </v-btn>
        </v-layout>
      </v-col>
    </v-row>
    <br><br><br><br><br><br>
  </v-container>
</template>

<script>

  import {  mdiLogoutVariant } from '@mdi/js'

  export default {
    components: {

    },

    data: () => ({
      mdiLogoutVariant
    }),

    computed: {
        
    },

    methods: {
      signOut() {
        window.sessionStorage.setItem('isAuth', false)
        window.sessionStorage.setItem('isAdmin', false)
        window.sessionStorage.setItem('agentCode', '')
        this.$router.push('/')
      }
    },

  }
</script>

